import React, {Component} from 'react';
import {connect} from 'react-redux';

import {TOGGLE_VIEW} from '../../actions/index';

class ViewButtons extends Component {
	handleChange(event) {
		this.props.dispatch({
			type: TOGGLE_VIEW,
			payload: event.target.getAttribute('data-view')
		});
	}

	render() {
			return (<span className={`sort-view-wrapper ${ this.props.categorySlug }`}>
			<button type="button" name="List View" className={`pull-right btn-sort-view ${('list' === this.props.view) ? 'active' : ''}`} onClick={this.handleChange.bind(this)} data-view="list">
		<span className="sr-only">List view</span>
			<span className="glyphicon glyphicon-th-list" data-view="list"></span>
		</button>
		<button type="button" name="Magazine View" className={`pull-right btn-sort-view ${('magazine' === this.props.view) ? 'active' : ''}`} onClick={this.handleChange.bind(this)} data-view="magazine">
			<span className="sr-only">Magazine view</span>
		<span className="glyphicon glyphicon-th-large" data-view="magazine"></span></button>
		</span>);
	}
}

function mapStateToProps({view}) {
	return {view};
}

export default connect(mapStateToProps)(ViewButtons);